import { createFileRoute } from '@tanstack/react-router';
import { ClassifierPage } from '../../features/classifier';

export const Route = createFileRoute('/portal/classifier/')({ component: ClassifierPage });
